export const TRACKING_SCOPES = {
  productView: 'track_product_view',
  login: 'track_login',
  logout: 'track_logout',
  order: 'track_order',
  shipping: 'track_shipping',
  customer: 'track_customer',
  catalog: 'track_catalog',
};
